
let _store: any = null;

export function initUtilsStore(storeInstance: any) {
    _store = storeInstance;
}

export function isAndorraEnabled(): boolean {
    if (!_store || !_store.state) { return false; }
    
    const state = _store.state as any;
    return !!(state.featureFlagsStore && state.featureFlagsStore.isAndorra);
}

export function convertBigIntToString(obj: any): any {
     if (typeof obj === 'bigint') {
        return obj.toString();
    }
    
     if (typeof obj === 'object' && obj !== null) {
        if (obj._isAMomentObject === true && typeof obj.toISOString === 'function') {
            return obj.toISOString();
        }

        if (obj instanceof Date && !isNaN(obj.getTime())) {
             return obj.toISOString();
        }

        if (Array.isArray(obj)) {
            return obj.map(convertBigIntToString);
        }

        const newObj: any = {};
        for (const key of Object.keys(obj)) {
            if (key !== '__ob__' && key !== '_isAMomentObject') { 
                newObj[key] = convertBigIntToString(obj[key]);
            }
        }
        return newObj;
    }

     return obj;
}

export function convertStringToBigInt(obj: any): any {
    if (typeof obj === 'string') {
        try {
            if (/^-?\d+$/.test(obj)) {
                return BigInt(obj);
            }
        } catch (e) {
              return obj;
        }
        return obj;
    }

    if (typeof obj === 'object' && obj !== null) {
        if (Array.isArray(obj)) {
            return obj.map(convertStringToBigInt);
        }
        const newObj: any = {};
        for (const key of Object.keys(obj)) {
             if (key !== '__ob__' && key !== '_isAMomentObject') {
                newObj[key] = convertStringToBigInt(obj[key]);
            }
        }
        return newObj;
    }

    return obj;
}
